(function () {
  var STORAGE_KEY = 'tru_compare_products';
  var MAX_ITEMS = 4;
  var lastFocusedBeforeModal = null;
  var productData = {};

  function readStore() {
    var raw = localStorage.getItem(STORAGE_KEY);
    var arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.slice(0, MAX_ITEMS) : [];
  }

  function writeStore(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function findIndex(items, id) {
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].id) === String(id)) return i;
    }
    return -1;
  }

  function readCompareData(toggle) {
    var dynamicFields = {};
    toggle.querySelectorAll('[data-compare-fields] [data-field]').forEach(function (el) {
      dynamicFields[el.getAttribute('data-field')] = el.innerHTML.trim();
    });

    var subscriptionsPercentageOff = {};
    try {
      subscriptionsPercentageOff = JSON.parse(toggle.getAttribute('data-subscriptions-percentage-off') || '{}') || {};
    } catch (e) {
      subscriptionsPercentageOff = {};
    }

    var supplyInMonths = {};
    try {
      supplyInMonths = JSON.parse(toggle.getAttribute('data-supply-in-months') || '{}') || {};
    } catch (e) {
      supplyInMonths = {};
    }

    return {
      id: toggle.getAttribute('data-compare-id'),
      handle: toggle.getAttribute('data-compare-handle'),
      title: toggle.getAttribute('data-compare-title'),
      url: toggle.getAttribute('data-compare-url'),
      image: toggle.getAttribute('data-compare-image'),
      rating: toggle.getAttribute('data-compare-rating') || '',
      subscriptionsPercentageOff: subscriptionsPercentageOff,
      supplyInMonths: supplyInMonths,
      dynamicFields: dynamicFields
    };
  }

  function addItem(item) {
    var items = readStore();
    if (findIndex(items, item.id) !== -1) return items;
    if (items.length >= MAX_ITEMS) return items;
    items.push(item);
    writeStore(items);
    return items;
  }

  function removeItem(id) {
    var items = readStore();
    var idx = findIndex(items, id);
    if (idx !== -1) {
      items.splice(idx, 1);
      writeStore(items);
    }
    return items;
  }

  function renderBar(items) {
    var bar = document.querySelector('[data-compare-bar]');
    if (!bar) return;

    var productsCount = bar.querySelector('[data-compare-count]');
    if (productsCount) productsCount.textContent = items.length;

    var slots = bar.querySelectorAll('[data-compare-slot]');
    slots.forEach(function (slot, index) {
      var item = items[index];
      var thumb = slot.querySelector('.compare-bar__thumb');
      var name = slot.querySelector('.compare-bar__name');
      var remove = slot.querySelector('[data-compare-remove]');

      if (item) {
        slot.classList.add('compare-bar__slot--filled');
        slot.classList.remove('compare-bar__slot--empty');
        thumb.style.backgroundImage = 'url("' + item.image + '")';
        name.textContent = item.title;
        remove.hidden = false;
        remove.dataset.compareId = item.id;
      } else {
        slot.classList.remove('compare-bar__slot--filled');
        slot.classList.add('compare-bar__slot--empty');
        thumb.style.backgroundImage = '';
        name.textContent = '';
        remove.hidden = true;
        remove.removeAttribute('data-compare-id');
      }
    });

    var compareBtn = bar.querySelector('[data-compare-open-modal]');
    if (compareBtn) {
      compareBtn.setAttribute('aria-disabled', items.length < 2 ? 'true' : 'false');
    }

    if (items.length > 0) {
      bar.hidden = false;
      requestAnimationFrame(function () { bar.setAttribute('data-state', 'open'); });
    } else {
      bar.removeAttribute('data-state');
      bar.hidden = true;
    }
  }

  function syncToggles(items) {
    var toggles = document.querySelectorAll('[data-compare-toggle]');
    toggles.forEach(function (toggle) {
      var id = toggle.getAttribute('data-compare-id');
      var input = toggle.querySelector('.product-compare-toggle__input');
      var isChecked = findIndex(items, id) !== -1;
      if (input) input.checked = isChecked;

      var isCompareFull = items.length >= MAX_ITEMS;
      var isBlocked = isCompareFull && !isChecked;

      toggle.classList.toggle('product-compare-toggle--disabled', isBlocked);
      if (input) input.disabled = isBlocked;
    });
  }

  function formatMoney(cents) {
    var amount = (Math.round(cents) / 100).toFixed(2);
    var fmt = (window.theme && window.theme.moneyFormat) ? window.theme.moneyFormat : '${{amount}}';
    return fmt
      .replace('{{amount_with_comma_separator}}', amount)
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100))
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount}}', amount);
  }

  function fillRating(ratingWrap, ratingValue) {
    var rating = parseFloat(ratingValue);
    if (!ratingValue || isNaN(rating)) {
      ratingWrap.parentNode.removeChild(ratingWrap);
      return;
    }

    var numEl = ratingWrap.querySelector('[data-rating-num]');
    numEl.textContent = rating.toFixed(1) + '/5';

    var filledStars = Math.round(rating);
    for (var i = 1; i <= 5; i++) {
      var star = cloneTemplate('[data-compare-star-template]');
      if (!star) break;
      star.classList.toggle('is-full', i <= filledStars);
      numEl.parentNode.insertBefore(star, numEl);
    }
  }

  function fetchProductData(handle) {
    if (productData[handle]) return Promise.resolve(productData[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status + ' for ' + handle);
        return response.json();
      })
      .then(function (product) {
        if (!Array.isArray(product.variants)) throw new Error('Invalid product JSON for ' + handle);
        productData[handle] = product;
        return product;
      });
  }

  function storedSubscriptionsPercentageOff(productId) {
    var items = readStore();
    var idx = findIndex(items, productId);
    return idx !== -1 ? items[idx].subscriptionsPercentageOff || null : null;
  }

  function storedSupplyInMonths(productId) {
    var items = readStore();
    var idx = findIndex(items, productId);
    return idx !== -1 ? items[idx].supplyInMonths || null : null;
  }

  function resolveDiscountPercentage(productId, variantId) {
    var percentages = storedSubscriptionsPercentageOff(productId);
    if (percentages && percentages[variantId] != null) return parseInt(percentages[variantId], 10) || 0;

    var modal = document.querySelector('[data-compare-modal]');
    return parseInt(modal.getAttribute('data-subscription-off') || '0', 10);
  }

  function resolveSubscription(product, variant) {
    var groups = Array.isArray(product.selling_plan_groups) ? product.selling_plan_groups : [];
    var plans = (groups[0] && Array.isArray(groups[0].selling_plans)) ? groups[0].selling_plans : [];
    var plan = plans[0] || null;
    var hasSubscription = plans.length > 0;

    if (hasSubscription) {
      var discountPercentage = resolveDiscountPercentage(product.id, variant.id);
      if (discountPercentage > 0) {
        var subPrice = Math.floor(variant.price * (100 - discountPercentage) / 100);
        return { hasSubscription: true, sellingPlanId: plan ? String(plan.id) : '', subPrice: subPrice, discountPercentage: discountPercentage };
      }
    }

    return { hasSubscription: false, sellingPlanId: '', subPrice: variant.price, discountPercentage: 0 };
  }

  function pricePerCountText(priceInCents, count) {
    if (!count || count < 1) return '';
    return formatMoney(Math.round(priceInCents / count)) + '/count';
  }

  function replaceContent(parent, node) {
    parent.innerHTML = '';
    if (node) parent.appendChild(node);
  }

  function cloneTemplate(selector) {
    var template = document.querySelector(selector);
    if (!template) return null;
    return template.content.firstElementChild.cloneNode(true);
  }

  function variantLabel(variant, months) {
    months = parseInt(months, 10);
    if (!months) return variant.option1 || variant.title;
    return months + (months === 1 ? ' month' : ' months');
  }

  function buildVariantButtons(product, activeIdx) {
    var list = document.createDocumentFragment();
    var supplyInMonths = storedSupplyInMonths(product.id) || {};

    product.variants.forEach(function (variant, idx) {
      var button = cloneTemplate('[data-compare-variant-template]');
      if (!button) return;

      button.textContent = variantLabel(variant, supplyInMonths[variant.id]);
      button.setAttribute('data-variant-idx', idx);
      button.setAttribute('data-product-id', product.id);
      button.classList.toggle('compare-atc__variant-btn--active', idx === activeIdx);
      button.classList.toggle('compare-atc__variant-btn--unavailable', !variant.available);

      list.appendChild(button);
    });

    return list;
  }

  function setAddButtonAvailability(addBtn, isAvailable) {
    addBtn.disabled = !isAvailable;
    addBtn.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');

    var labelAttr = isAvailable ? 'data-lang-available' : 'data-lang-sold-out';
    addBtn.querySelector('[data-atc-text]').textContent = addBtn.getAttribute(labelAttr) || '';
  }

  function fillPurchaseOptionDataAndSelection(option, radioName, isSelected, priceInCents, variantCount) {
    option.querySelector('[data-price]').textContent = formatMoney(priceInCents);
    option.querySelector('[data-per-count]').textContent = pricePerCountText(priceInCents, variantCount);

    var radio = option.querySelector('input[type="radio"]');
    radio.name = radioName;
    radio.checked = isSelected;
  }

  function buildAtcElement(product, variantIdx, purchaseType) {
    variantIdx = variantIdx || 0;

    var atc = cloneTemplate('[data-compare-atc-template]');
    if (!atc) return null;

    var variant = product.variants[variantIdx];
    var variantCount = parseInt(variant.title, 10);
    var sub = resolveSubscription(product, variant);

    var isSubscription = (purchaseType || (sub.hasSubscription ? 'sub' : 'otp')) === 'sub' && sub.hasSubscription;
    var radioName = 'compare-pt-' + product.id;

    atc.setAttribute('data-product-id', product.id);
    atc.querySelector('[data-variant-list]').appendChild(buildVariantButtons(product, variantIdx));

    var subOption = atc.querySelector('[data-option="sub"]');
    if (sub.hasSubscription) {
      subOption.querySelector('[data-sub-title]').textContent = 'Subscribe & Save ' + sub.discountPercentage + '%';
      fillPurchaseOptionDataAndSelection(subOption, radioName, isSubscription, sub.subPrice, variantCount);
    } else {
      subOption.parentNode.removeChild(subOption);
    }

    var otpOption = atc.querySelector('[data-option="otp"]');
    fillPurchaseOptionDataAndSelection(otpOption, radioName, !isSubscription, variant.price, variantCount);

    var addBtn = atc.querySelector('[data-compare-cart-add]');
    addBtn.setAttribute('data-variant-id', variant.id);
    addBtn.setAttribute('data-selling-plan-id', isSubscription ? sub.sellingPlanId : '');
    setAddButtonAvailability(addBtn, variant.available !== false);

    return atc;
  }

  function renderAddToCartSection(items) {
    var actionsRow = document.querySelector('[data-compare-row="actions"]');
    var existingCells = actionsRow.querySelectorAll('td');
    existingCells.forEach(function (c) { c.parentNode.removeChild(c); });

    items.forEach(function (item) {
      var td = document.createElement('td');
      td.className = 'compare-table__cell compare-table__cell--action';
      td.setAttribute('data-label', actionsRow.getAttribute('data-row-label') || '');
      replaceContent(td, cloneTemplate('[data-compare-loading-template]'));
      actionsRow.appendChild(td);

      (function (currentItem, currentTd) {
        fetchProductData(currentItem.handle)
          .then(function (product) {
            replaceContent(currentTd, buildAtcElement(product, 0, null));
          })
          .catch(function (fetchErr) {
            console.error('[Compare] fetch error for "' + currentItem.handle + '":', fetchErr);
          });
      })(item, td);
    });
  }

  function addToCartFromCompare(variantId, sellingPlanId, btn) {
    btn.disabled = true;
    btn.classList.add('loading');
    var body = { id: String(variantId), quantity: 1 };
    if (sellingPlanId) body.selling_plan = String(sellingPlanId);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function (res) {
      if (!res.ok) throw new Error('failed');
      return res.json();
    })
    .then(function () {
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
      setTimeout(function () {
        var cartIcon = document.querySelector('[data-js-cart-icon]');
        if (cartIcon) cartIcon.click();
        btn.disabled = false;
        btn.classList.remove('loading');
      }, 400);
    })
    .catch(function () {
      btn.disabled = false;
      btn.classList.remove('loading');
    });
  }

  function renderProductTitleRow(items) {
    var row = document.querySelector('[data-compare-product-row]');
    if (!row) return;

    var table = row.closest('[data-compare-table]');
    if (table) table.setAttribute('data-products-count', items.length);

    var modal = row.closest('[data-compare-modal]');
    if (modal) modal.setAttribute('data-products-count', items.length);

    row.innerHTML = '';

    var corner = cloneTemplate('[data-compare-corner-template]');
    if (corner) row.appendChild(corner);

    items.forEach(function (item) {
      var th = cloneTemplate('[data-compare-product-template]');
      if (!th) return;

      th.querySelectorAll('[data-product-link]').forEach(function (link) {
        link.setAttribute('href', item.url);
      });

      var image = th.querySelector('[data-product-image]');
      image.setAttribute('src', item.image);
      image.setAttribute('alt', item.title);

      th.querySelector('[data-product-title]').textContent = item.title;

      var removeBtn = th.querySelector('[data-compare-modal-remove]');
      removeBtn.setAttribute('data-compare-id', item.id);
      removeBtn.setAttribute('aria-label', 'Remove ' + item.title);

      fillRating(th.querySelector('[data-product-rating]'), item.rating);

      row.appendChild(th);
    });
  }

  function renderRows(items) {
    var rows = document.querySelectorAll('[data-compare-row]');
    rows.forEach(function (row) {
      var key = row.getAttribute('data-compare-row');

      var existingCells = row.querySelectorAll('td');
      existingCells.forEach(function (c) { c.parentNode.removeChild(c); });

      if (key === 'actions') {
        renderAddToCartSection(items);
        return;
      }

      var rowLabel = row.getAttribute('data-row-label') || '';

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var td = document.createElement('td');
        td.className = 'compare-table__cell';
        td.setAttribute('data-label', rowLabel);
        td.innerHTML = (item.dynamicFields && item.dynamicFields[key]) || '—';
        row.appendChild(td);
      }
    });
  }

  function getFocusable(container) {
    return container.querySelectorAll(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), input:not([disabled])'
    );
  }

  function trapFocus(e) {
    var modal = document.querySelector('[data-compare-modal]');
    if (!modal || modal.getAttribute('data-state') !== 'open') return;
    if (e.key !== 'Tab') return;
    var focusable = getFocusable(modal);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openModal() {
    var items = readStore();
    if (items.length < 2) return;

    var modal = document.querySelector('[data-compare-modal]');

    renderProductTitleRow(items);
    renderRows(items);

    lastFocusedBeforeModal = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      modal.setAttribute('data-state', 'open');
      var closeBtn = modal.querySelector('[data-compare-modal-close]');
      var focusable = getFocusable(modal);
      var target = closeBtn || focusable[0];
      target.focus();
    });
    document.addEventListener('keydown', onKeyDown);
    document.body.classList.add('compare-modal-open');
  }

  function closeModal() {
    var modal = document.querySelector('[data-compare-modal]');
    modal.removeAttribute('data-state');
    modal.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKeyDown);
    document.body.classList.remove('compare-modal-open');

    var hidden = false;
    var hide = function () {
      if (hidden) return;
      hidden = true;
      modal.hidden = true;
      modal.removeEventListener('transitionend', onEnd);
    };
    var onEnd = function (e) {
      if (e.target === modal) hide();
    };
    modal.addEventListener('transitionend', onEnd);
    setTimeout(hide, 400);

    if (lastFocusedBeforeModal && typeof lastFocusedBeforeModal.focus === 'function') {
      lastFocusedBeforeModal.focus();
    }
    lastFocusedBeforeModal = null;
  }

  function isPurchaseTypeRadio(el) {
    return el.type === 'radio' && el.name && el.name.indexOf('compare-pt-') === 0;
  }

  function findProductById(productId) {
    var keys = Object.keys(productData);
    for (var k = 0; k < keys.length; k++) {
      if (String(productData[keys[k]].id) === String(productId)) return productData[keys[k]];
    }
    return null;
  }

  function findVariantById(product, variantId) {
    for (var j = 0; j < product.variants.length; j++) {
      if (String(product.variants[j].id) === String(variantId)) return product.variants[j];
    }
    return null;
  }

  function onPurchaseTypeChange(radio) {
    var container = radio.closest('[data-compare-atc]');
    if (!container) return;

    var addBtn = container.querySelector('[data-compare-cart-add]');
    if (!addBtn) return;

    var product = findProductById(container.getAttribute('data-product-id'));
    if (!product) return;

    var variant = findVariantById(product, addBtn.getAttribute('data-variant-id'));
    if (!variant) return;

    var sellingPlanId = radio.value === 'sub' ? resolveSubscription(product, variant).sellingPlanId : '';
    addBtn.setAttribute('data-selling-plan-id', sellingPlanId);
  }

  function onCompareCheckboxChange(input) {
    var toggle = input.closest('[data-compare-toggle]');
    if (!toggle) return;

    var item = readCompareData(toggle);
    var items = input.checked ? addItem(item) : removeItem(item.id);

    renderBar(items);
    syncToggles(items);
  }

  function onDocumentChange(e) {
    var input = e.target.closest('.product-compare-toggle__input');
    if (input) onCompareCheckboxChange(input);
  }

  function onModalChange(e) {
    if (isPurchaseTypeRadio(e.target)) onPurchaseTypeChange(e.target);
  }

  function onBarClick(e) {
    var removeBtn = e.target.closest('[data-compare-remove]');
    if (removeBtn) {
      var id = removeBtn.getAttribute('data-compare-id');
      if (id) {
        var items = removeItem(id);
        renderBar(items);
        syncToggles(items);
      }
      return;
    }

    var clearBtn = e.target.closest('[data-compare-clear]');
    if (clearBtn) {
      writeStore([]);
      renderBar([]);
      syncToggles([]);
      closeModal();
      return;
    }

    var compareBtn = e.target.closest('[data-compare-open-modal]');
    if (compareBtn) {
      e.preventDefault();
      if (compareBtn.getAttribute('aria-disabled') !== 'true') openModal();
    }
  }

  function onModalClick(e) {
    var variantBtn = e.target.closest('[data-compare-atc-variant]');
    if (variantBtn) {
      var container = variantBtn.closest('[data-compare-atc]');
      if (!container) return;
      var product = findProductById(container.getAttribute('data-product-id'));
      if (!product) return;

      var variantIdx = parseInt(variantBtn.getAttribute('data-variant-idx'), 10);
      var checkedRadio = container.querySelector('input[type="radio"]:checked');
      var currentType = checkedRadio ? checkedRadio.value : null;
      var td = container.closest('td');
      if (td) replaceContent(td, buildAtcElement(product, variantIdx, currentType));
      return;
    }

    var atcBtn = e.target.closest('[data-compare-cart-add]');
    if (atcBtn) {
      if (atcBtn.disabled) return;

      var variantId = atcBtn.getAttribute('data-variant-id');
      var sellingPlanId = atcBtn.getAttribute('data-selling-plan-id') || null;
      if (variantId) addToCartFromCompare(variantId, sellingPlanId, atcBtn);
      return;
    }

    var removeBtn = e.target.closest('[data-compare-modal-remove]');
    if (removeBtn) {
      var id = removeBtn.getAttribute('data-compare-id');
      if (id) {
        var items = removeItem(id);
        renderBar(items);
        syncToggles(items);
        if (items.length < 2) {
          closeModal();
        } else {
          renderProductTitleRow(items);
          renderRows(items);
        }
      }
      return;
    }

    if (e.target.closest('[data-compare-modal-close]')) closeModal();
  }

  function onKeyDown(e) {
    if (e.key === 'Escape') {
      var modal = document.querySelector('[data-compare-modal]');
      if (modal && modal.getAttribute('data-state') === 'open') closeModal();
      return;
    }
    trapFocus(e);
  }

  function containsToggle(node) {
    if (node.nodeType !== 1) return false;
    return node.matches('[data-compare-toggle]') || node.querySelector('[data-compare-toggle]') !== null;
  }

  function hasNewToggles(mutations) {
    return mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes, containsToggle);
    });
  }

  function init() {
    var items = readStore();
    renderBar(items);
    syncToggles(items);

    document.addEventListener('change', onDocumentChange);

    var bar = document.querySelector('[data-compare-bar]');
    if (bar) bar.addEventListener('click', onBarClick);

    var modal = document.querySelector('[data-compare-modal]');
    if (modal) {
      modal.addEventListener('click', onModalClick);
      modal.addEventListener('change', onModalChange);
    }

    var syncScheduled = false;
    var observer = new MutationObserver(function (mutations) {
      if (syncScheduled || !hasNewToggles(mutations)) return;

      syncScheduled = true;
      requestAnimationFrame(function () {
        syncScheduled = false;
        syncToggles(readStore());
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
